import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import ProjectIntro from '../components/ProjectIntro';
import ProjectVideo from '../components/ProjectVideo';
import CommunityVision from '../components/CommunityVision';
import SectionsOverview from '../components/SectionsOverview';

const LeProjetPage = () => {
  useEffect(() => {
    document.title = 'Le Projet — MonAlerte';
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <ProjectIntro />
        <ProjectVideo />
        <CommunityVision />
        <SectionsOverview />
        {/* Le parcours bêta historique est remplacé par /rejoindre et sa collecte e-mail. */}
      </main>
      <Footer />
    </>
  );
};

export default LeProjetPage;
